// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3GlzQ","errorLogs":"EditorFooter_errorLogs__1Hzd4"};